import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
// const AboutUs = () => import(/* webpackChunkName: "group" */ '@/pages/about-us/about-us')
import Practice from '@/pages/practice/practice'
import Office from '@/pages/office/office'
import MeetDoctor from '@/pages/meet-doctor/meet-doctor'
import MeetTeam from '@/pages/meet-team/meet-team'
import AboCertification from '@/pages/abo-certification/abo-certification'
import PatientInfo from '@/pages/patient-info/patient-info'
import OfficeVisits from '@/pages/office-visits/office-visits'
import OfficeForms from '@/pages/office-forms/office-forms'
import FinancialInfo from '@/pages/financial-info/financial-info'
import BracesMaintenance from '@/pages/braces-maintenance/braces-maintenance'
import InstructionalVideos from '@/pages/instructional-videos/instructional-videos'
import OrthodonticEmergency from '@/pages/orthodontic-emergency/orthodontic-emergency'
import AfterPhotos from '@/pages/after-photos/after-photos'
import Faqs from '@/pages/faqs/faqs'
import Treatment from '@/pages/treatment/treatment'
import OrthodonticsChildren from '@/pages/orthodontics-children/orthodontics-children'
import OrthodonticsTeens from '@/pages/orthodontics-teens/orthodontics-teens'
import OrthodonticsAdults from '@/pages/orthodontics-adults/orthodontics-adults'
import TypesBraces from '@/pages/types-braces/types-braces'
import TwoPhaseTreatment from '@/pages/two-phase-treatment/two-phase-treatment'
import Covid19 from '@/pages/covid-19/covid-19'
import News from '@/pages/news/news'
import Contact from '@/pages/contact-us/contact-us'
import Blog from '@/pages/blog/blog'
import BlogPost from '@/pages/blog-post/blog-post'
import Category from '@/pages/category/category'
import ThankYou from '@/pages/thank-you/thank-you'
import accessibilityStatement from '@/pages/accessibility-statement/accessibility-statement'
import PageNotFound from '@/pages/404/404'
import scrollBehavior from '@/shared/functionality/scroll-behavior'
import Styleguide from '@/styleguide/styleguide'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      navigation: true,
      component: Home
    },
    {
      path: '/practice',
      name: 'Practice',
      navigation: true,
      component: Practice
    },
    {
      path: '/practice/office',
      name: 'Office',
      navigation: true,
      component: Office
    },
    {
      path: '/practice/meet-doctor',
      name: 'Meet Doctor',
      navigation: true,
      component: MeetDoctor
    },
    {
      path: '/practice/meet-team',
      name: 'Meet Team',
      navigation: true,
      component: MeetTeam
    },
    {
      path: '/practice/abo-certification',
      name: 'Abo Certification',
      navigation: true,
      component: AboCertification
    },
    {
      path: '/patient-info',
      name: 'Patient Info',
      navigation: true,
      component: PatientInfo
    },
    {
      path: '/patient-info/office-visits',
      name: 'Office Visits',
      navigation: true,
      component: OfficeVisits
    },
    {
      path: '/patient-info/office-forms',
      name: 'Office Forms',
      navigation: true,
      component: OfficeForms
    },
    {
      path: '/patient-info/financial-info',
      name: 'Financial Info',
      navigation: true,
      component: FinancialInfo
    },
    {
      path: '/patient-info/braces-maintenance',
      name: 'Braces Maintenance',
      navigation: true,
      component: BracesMaintenance
    },
    {
      path: '/patient-info/instructional-videos',
      name: 'Instructional Videos',
      navigation: true,
      component: InstructionalVideos
    },
    {
      path: '/patient-info/orthodontic-emergency',
      name: 'Orthodontic Emergency',
      navigation: true,
      component: OrthodonticEmergency
    },
    {
      path: '/patient-info/after-photos',
      name: 'After Photos',
      navigation: true,
      component: AfterPhotos
    },
    {
      path: '/patient-info/faqs',
      name: 'faqs',
      navigation: true,
      component: Faqs
    },
    {
      path: '/treatment',
      name: 'treatment',
      navigation: true,
      component: Treatment
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      navigation: true,
      component: ThankYou
    },
    {
      path: '/treatment/orthodontics-children',
      name: 'orthodontics-children',
      navigation: true,
      component: OrthodonticsChildren
    },
    {
      path: '/treatment/orthodontics-teens',
      name: 'orthodontics-teens',
      navigation: true,
      component: OrthodonticsTeens
    },
    {
      path: '/treatment/orthodontics-adults',
      name: 'orthodontics-adults',
      navigation: true,
      component: OrthodonticsAdults
    },
    {
      path: '/treatment/types-braces',
      name: 'types-braces',
      navigation: true,
      component: TypesBraces
    },
    {
      path: '/treatment/two-phase-treatment',
      name: 'two-phase-treatment',
      navigation: true,
      component: TwoPhaseTreatment
    },
    {
      path: '/news',
      name: 'news',
      navigation: true,
      component: News
    },
    {
      path: '/covid-19',
      name: 'COVID-19',
      navigation: true,
      component: Covid19
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      navigation: true,
      component: Contact
    },
    {
      path: '/accessibility-statement',
      name: 'Accessibility Statement',
      navigation: false,
      component: accessibilityStatement
    },
    {
      path: '/blog',
      name: 'blog',
      navigation: true,
      component: Blog
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/blog/:id',
      name: 'BlogPost',
      component: BlogPost
    },
    {
      path: '/topic/:slug',
      name: 'Category',
      component: Category
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: PageNotFound
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js